define('view/controller/booking/datetime/DateTimeStepInlineEventDateLayout',['require','view/controller/booking/datetime/DateTimeStepDefaultLayout'],function (require) {

	var DateTimeStepDefaultLayout = require('view/controller/booking/datetime/DateTimeStepDefaultLayout');
	
	/**
	 * Datetime step layout with inline date navigation
	 * 
	 * @class DateTimeStepInlineEventDateLayout
	 */
	return DateTimeStepDefaultLayout.extend({
	
	    template: '#datetime_step_eventdate_layout',

        regions: {
            datetime: '#sb_datetimeview_container',
            sidebar: '#sb_sidebar_container'
        },

        supportsTimelineNavigation: function () {
            return false;
        },

        /**
         * Returns region for datepicker
         *
         * @return Marionette.Region
         */
        getDateRegion: function () {
            return null;
        },

        /**
         * Returns region for timepicker
         *
         * @return Marionette.Region
         */
        getTimeRegion: function () {
            return this.datetime;
        },

        /**
         * Returns region for datetimepicker
         *
         * @return Marionette.Region
         */
        getDateTimeRegion: function () {
            return this.datetime;
        },

	});

});
